import React, { Component } from 'react';
import { Helmet } from 'react-helmet';

// API
import * as API  from '../../utils/api';

// Components
import Header from '../../components/Global/Header';
import FormContainer from '../../components/Global/FormContainer';

class DeclineMaintainerInvitation extends Component {

  state = {
    token: '',
    name: 'Alex',
  }

  componentDidMount() {
    const { token } = this.props.match.params;

    API.getInvitationInfo(token)

    API.declineMaintainerInvite(token)
      .then(response => {
        console.log('response: ', response)
      })
  }

  render() {
    const { path, appName } = this.props;
    const { name } = this.state;

    return (
      <div className="onboarding">
        <Helmet>
          <title>{appName} | Decline Invite</title>
        </Helmet>
        <Header path={ path }/>
        <FormContainer>
          <header>
            <h2>You've declined to manage {name}'s profile</h2>
          </header>
          <div>
            <p>
              {name} will be notified that you've declined to manage their profile.
            </p>
            <p>
              If this was done by accident, please contact {name} directly to request a new invitation.
            </p>
          </div>
        </FormContainer>
      </div>
    );
  }
}

export default DeclineMaintainerInvitation


// WEBPACK FOOTER //
// ./src/screens/Onboarding/DeclineMaintainerInvitation.js